export const ADD_IFSC_USER_MASTER_UPLOAD = 'ADD_IFSC_USER_MASTER_UPLOAD'
export const ADD_IFSC_USER_MASTER_UPLOAD_FAILURE = 'ADD_IFSC_USER_MASTER_UPLOAD_FAILURE'
export const ADD_IFSC_USER_MASTER_UPLOAD_SUCCESS = 'ADD_IFSC_USER_MASTER_UPLOAD_SUCCESS'
export const ADD_IFSC_USER_MASTER_UPLOAD_FAILURE_FILE = 'ADD_IFSC_USER_MASTER_UPLOAD_FAILURE_FILE'

export const addIfscUserMasterUpload = (data) => {
    return {
        type: ADD_IFSC_USER_MASTER_UPLOAD,
        data
    }
}

export const addIfscUserMasterUploadFailure  = (data) => {
    return {
        type: ADD_IFSC_USER_MASTER_UPLOAD_FAILURE,
        data
    }
}

export const addIfscUserMasterUploadFailureFile = (data) => {
    return {
        type: ADD_IFSC_USER_MASTER_UPLOAD_FAILURE_FILE,
        data
    }
}

export const addIfscUserMasterUploadSuccess = (data) => {
    return {
        type: ADD_IFSC_USER_MASTER_UPLOAD_SUCCESS,
        data
    }
}

export const IFSC_USER_MASTER_TEMPLATE_REQUEST = 'IFSC_USER_MASTER_TEMPLATE_REQUEST';
export const IFSC_USER_MASTER_TEMPLATE_SUCCESS = 'IFSC_USER_MASTER_TEMPLATE_SUCCESS';
export const IFSC_USER_MASTER_TEMPLATE_FAILURE = 'IFSC_USER_MASTER_TEMPLATE_FAILURE';

export const ifscUserMasterTemplateRequest = () => {
    return {
        type: IFSC_USER_MASTER_TEMPLATE_REQUEST,
    }
}

export const ifscUserMasterTemplateSuccess = (data) => {
    return {
        type: IFSC_USER_MASTER_TEMPLATE_SUCCESS,
        data
    }
}

export const ifscUserMasterTemplateFailure = (data) => {
    return {
        type: IFSC_USER_MASTER_TEMPLATE_FAILURE,
        data
    }
}


export const IFSC_USER_MASTER_DATA_EXCEL_SUCCESS = 'IFSC_USER_MASTER_DATA_EXCEL_SUCCESS';
export const IFSC_USER_MASTER_DATA_EXCEL_FAILURE = 'IFSC_USER_MASTER_DATA_EXCEL_FAILURE';
export const IFSC_USER_MASTER_DATA_EXCEL_REQUEST = 'IFSC_USER_MASTER_DATA_EXCEL_REQUEST';

export const ifscUserMasterDataExcelRequest = () => {
    return {
        type: IFSC_USER_MASTER_DATA_EXCEL_REQUEST,
    }
}

export const ifscUserMasterDataExcelSuccess = (data) => {
    return {
        type: IFSC_USER_MASTER_DATA_EXCEL_SUCCESS,
        data
    }
}

export const ifscUserMasterDataExcelFailure = (data) => {
    return {
        type: IFSC_USER_MASTER_DATA_EXCEL_FAILURE,
        data
    }
}

export const IFSC_USER_MASTER_LIST_REQUEST = 'IFSC_USER_MASTER_LIST_REQUEST';
export const IFSC_USER_MASTER_LIST_SUCCESS = 'IFSC_USER_MASTER_LIST_SUCCESS';
export const IFSC_USER_MASTER_LIST_FAILURE = 'IFSC_USER_MASTER_LIST_FAILURE';

export const ifscUserMasterListRequest = (data) => ({
  type: IFSC_USER_MASTER_LIST_REQUEST,
  data
});

export const ifscUserMasterListSuccess = (data) => ({
  type: IFSC_USER_MASTER_LIST_SUCCESS,
  data
});

export const ifscUserMasterListFailure = (data) => ({
  type: IFSC_USER_MASTER_LIST_FAILURE,
  data
});
